import { color, spacing } from '@/theme/tokens';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const Asterisk = styled(Typography)`
    color: ${color.brand[50]};
    margin-left: ${spacing[2]};
`;
